import { Affix, Button, Card } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getData } from "../../../apiServices/common";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import AddPurchaseOrderForm from "./AddFoldingRequirementForm";
import { FOLDING_REQUIREMENT_VIEW } from "apiServices/API_ENDPOINTS";
import AddFoldingRequirementForm from "./AddFoldingRequirementForm";

export default function ViewFoldingRequirement(props) {
  // Props
  const { width } = props;

  // Router
  let { id } = useParams();
  const navigate = useNavigate();

  // States
  const [info, setInfo] = useState();
  

  // Others
  const propertyFormRef = useRef(null);
  const edit_url = `${FOLDING_REQUIREMENT_VIEW}/${id}`;

  const discartForm = () => {
    navigate("/digitalization/folding-requirement");
  };

  const getPOInfo = useCallback(async () => {
    let res = await getData(edit_url);

    if (res) {
      let masterData = res.data.data;
      setInfo(masterData);
      const po_data = masterData ? masterData.purchase_order_details : null;

      const po_details = po_data.map((item) => {
        const sizes = {};

        item?.sizes.forEach((size) => {
          sizes[size?.name + "_" + size?.id] = size?.sales_order_quantity;
        });
        return {
          ...item,
          style_id: item.style.id,
          color_id: item.color.id,
          ...sizes,
        };
      });

      
    }
  }, [edit_url]);

  useEffect(() => {
    getPOInfo();
  }, [getPOInfo]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="View Folding Requirement"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Back
              </Button>,
            ]}
          ></Header>
        </Card>
      </Affix>

      <AddFoldingRequirementForm
        ref={propertyFormRef}
        info={info}
        view={true}
        mode={"view"}
      />
    </>
  );
}
